module.exports = __webpack_public_path__ + "img/viktor.a1114233.webp";